import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import opening from './img/ReadySetReady/opening.png';
import tasklist from './img/ReadySetReady/tasklist.png';
import butterflyone from './img/ReadySetReady/butterfly1.png';
import pirateone from './img/ReadySetReady/pirate1.png';
import piratetwo from './img/ReadySetReady/pirate2.png';


export const ReadySetReady = ({}) => {



	return (
		<div className="container-fluid appdesc corners">
 	<div className="row padrow">
 	  <div className="col-md-8 col-lg-8">
           <h2>Ready Set Ready</h2>
 	  </div>
       <div className="col-md-4 col-lg-4">
           <a href='https://play.google.com/store/apps/details?id=com.helenssc.toddlerlist.android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' className="appimage img-responsive d-block mx-auto auditpic googlebadge"/></a>
     </div>
 	  </div>
 	 <div className="row padrow">
  <div className="col-md-12 col-lg-12">
           This innovative app is meant to help your toddler through his daily routine.  This app is intended for tablets for best graphics display.
           </div>
 	  </div>
 	  <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
           <img src={opening} alt="Opening screen of ReadySetReady Application" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
 	 </div>

 	  </div>
           <div className="row padrow">
           <div className="col-md-12 col-lg-12">
           Pick up to eight tasks as represented by picture icons.
 	  </div>
 	  </div>
 	  <div className="row padrow">

 	   <div className="col-md-12 col-lg-12 text-center">
             <img src={tasklist} alt="Task List of ReadySetReady Application" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
            </div>
           </div>

           <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
 	  As each task is completed, progress is made in the graphics screen:
           </div>
 	  </div>
           <div className="row padrow">
           <div className="col-md-6 col-lg-6">
            <img src={butterflyone} alt="Butterfly task screen" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
 	  </div>
 	  <div className="col-md-6 col-lg-6">
            <img src={pirateone} alt="Pirate task screen" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
 	  </div>
           </div>
           <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
 	  Followed by a brief success screen:
          </div>
           </div>

           <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
 	    <img src={piratetwo} alt="Pirate success screen" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
           </div>
           </div>

           <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
 	  Let us know <Link to="/feedback" >
		feedback form
		</Link> if you want an expanded version, or if there is someway we can make this app more useful to you.  Of course, also let us know if you experience any glitches.  We look forward to your comments!
          </div>

 	  </div>
 	</div>


			)


}
